export const cookieConsentCookieName = "CookieConsent";
